<template>
  <div class="copilot-typing-indicator" role="status" aria-live="polite">
    <div class="copilot-typing-indicator__bubble">
      <span class="copilot-typing-indicator__label">{{ label }}</span>
      <span class="copilot-typing-indicator__dots" aria-hidden="true">
        <span class="copilot-typing-indicator__dot"></span>
        <span class="copilot-typing-indicator__dot"></span>
        <span class="copilot-typing-indicator__dot"></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopilotTypingIndicator',
  computed: {
    label() {
      return this.$t('copilot.thinking')
    },
  },
}
</script>

<style scoped lang="scss">
.copilot-typing-indicator {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.copilot-typing-indicator__bubble {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 72%;
  padding: 10px 14px;
  border-radius: 16px;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}

.copilot-typing-indicator__label {
  font-weight: 500;
}

.copilot-typing-indicator__dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.copilot-typing-indicator__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6b7280;
  animation: copilot-typing-bounce 1.2s infinite ease-in-out;
}

.copilot-typing-indicator__dot:nth-child(2) {
  animation-delay: 0.15s;
}

.copilot-typing-indicator__dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes copilot-typing-bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 0.45;
  }

  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
</style>
